var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.7496 6C12.7496 5.58579 12.4138 5.25 11.9996 5.25C11.5854 5.25 11.2496 5.58579 11.2496 6V11.25H6.00195C5.58774 11.25 5.25195 11.5858 5.25195 12C5.25195 12.4142 5.58774 12.75 6.00195 12.75H11.2496V18C11.2496 18.4142 11.5854 18.75 11.9996 18.75C12.4138 18.75 12.7496 18.4142 12.7496 18V12.75H18.002C18.4162 12.75 18.752 12.4142 18.752 12C18.752 11.5858 18.4162 11.25 18.002 11.25H12.7496V6Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
